import { useState, useEffect } from 'react';

/** Tailwind `lg` breakpoint (1024px). For picking which header user-menu node is visible. */
export function useTailwindLg() {
  const query = '(min-width: 1024px)';
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return matches;
}

export default useTailwindLg;
